import { render, staticRenderFns } from "./LeakageCauseWorksBeforeQuestion.vue?vue&type=template&id=60526bb5&scoped=true"
import script from "./LeakageCauseWorksBeforeQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseWorksBeforeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60526bb5",
  null
  
)

export default component.exports